import React from 'react';
import { useSelector } from 'react-redux';
import { ReportFailed } from 'src/components/shared/report/ReportFailed';
import { RootState } from 'src/features';
import { ReportError } from 'src/models/report/ReportError';

export const ReportFailedDialog: React.FC = () => {
  const reportStatus = useSelector((state: RootState) => state.resort.reportStatus);
  let reportError: ReportError | undefined = undefined;
  let invalidChar: string[] | undefined = undefined;
  if (reportStatus?.state === 'error') {
    reportError = reportStatus.error;
  }

  if (reportError === undefined) {
    return <></>;
  } else {
    if (reportError.type === 'invalid-char') {
      invalidChar = reportError.char;
    }
  }

  return <ReportFailed errorType={reportError.type} invalidChar={invalidChar} />;
};
